module.exports = __webpack_public_path__ + "static/media/real-estate.76e3a4a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/real-estate.svg
// module id = 1008
// module chunks = 0